/**
 * Performance logging utility class
 * @class Performance
 */

import slsLogger from './index';

export class Performance {
  static timing = window.performance?.timing;
  static customFPT = 0;

  static init() {
    if (!this.timing) {
      console.warn('当前浏览器不支持performance API');
      return;
    }

    //页面资源加载完后，上报数据
    window.addEventListener('load', () => {
      setTimeout(() => {
        const [navigation] = performance.getEntriesByType('navigation');
        const loadTime = navigation.loadEventEnd - navigation.startTime; // 正确方式
        const pageUrl = window.location.href;
        // 获取所有资源加载记录
        const resources = performance.getEntriesByType('resource') || [];
        // 筛选出 JS 文件 // 过滤图片、CSS 等其他资源
        const jsFiles = resources.filter(
          (item) =>
            /js(\?.*)?$/.test(item.name) && ['script', 'fetch', 'xmlhttprequest', 'link'].includes(item.initiatorType)
        );
        const resourceList = [];
        // 输出每个脚本的加载时间
        jsFiles.forEach((item) => {
          resourceList.push({
            url: item.name,
            duration: (item.responseEnd - item.startTime).toFixed(2) // 保留两位小数
          });
        });

        // 如果加载时间超过4秒，单独上报慢加载日志
        if (loadTime > 4000) {
          logger.log('页面初始加载时间过长', { loadTime, pageUrl, resourceList });
          slsLogger.console({
            action: 'page_load_slow',
            pageTitle: document.title,
            extra: {
              message: `初始加载时间过长: ${loadTime} ms for ${pageUrl}; 获取资源加载耗时查看详情`,
              resourceList
            }
          });
        }

        slsLogger.console({
          action: 'performance',
          pageTitle: document.title,
          extra: { ...this.getTimings() }
        });

        setTimeout(() => {
          // 1分钟后 清空资源列表，释放内存
          resourceList.length = 0;
        }, 1 * 60 * 1000);
      }, 1000);
    });
  }

  //自定义计算白屏时间
  static record(router) {
    const setFPT = () => {
      if (window.performance && window.performance.now) {
        this.customFPT = window.performance.now().toFixed(4);
        if (this.customFPT > 4000) {
          slsLogger.console({
            action: 'first_paint_slow',
            pageTitle: document.title,
            extra: {
              message: `白屏时间过长 共耗时: ${this.customFPT} ms`
            }
          });
        }
      }
    };
    return {
      created: () => {
        if (router) {
          router.isReady().then(() => {
            setFPT();
          });
        } else {
          setFPT();
        }
      }
    };
  }

  static getTimings() {
    if (!this.timing) {
      console.warn('当前浏览器不支持performance API');
      return {};
    }

    return {
      redirect: this.getRedirectTime(),
      dns: this.getDnsTime(),
      tcp: this.getTcpTime(),
      ttfb: this.getTimeOfFirstByte(),
      req: this.getReqTime(),
      ppdt: this.getParsePureDomTime(),
      dclt: this.getDomContentLoadTime(),
      fpt: this.getFirstPaintTime(),
      load: this.getLoadTime()
    };
  }

  // 重定向耗时
  static getRedirectTime() {
    return Performance.timing.redirectEnd - Performance.timing.redirectStart;
  }
  // DNS解析耗时
  static getDnsTime() {
    return Performance.timing.domainLookupEnd - Performance.timing.domainLookupStart;
  }
  // TCP连接耗时
  static getTcpTime() {
    return Performance.timing.connectEnd - Performance.timing.connectStart;
  }
  // 首字节时间
  static getTimeOfFirstByte() {
    return Performance.timing.responseStart - Performance.timing.navigationStart;
  }
  // 请求耗时
  static getReqTime() {
    return Performance.timing.responseEnd - Performance.timing.responseStart;
  }
  // 解析DOM树耗时 不包含资源加载和执行时间
  static getParsePureDomTime() {
    return Performance.timing.domInteractive - Performance.timing.domLoading;
  }
  // DOMContentLoaded耗时 包含vue, js css等资源的加载和执行
  static getDomContentLoadTime() {
    return Performance.timing.domComplete - Performance.timing.domInteractive;
  }
  // 首次绘制时间
  static getFirstPaintTime() {
    // first paint time, 首次渲染时间, 即白屏时间
    // getEntriesByName 浏览器兼容性不好，故有时需要自己去定义
    return Math.round(
      (window.performance.getEntriesByName &&
        window.performance.getEntriesByName('first-paint') &&
        window.performance.getEntriesByName('first-paint')[0] &&
        window.performance.getEntriesByName('first-paint')[0].startTime) ||
        this.customFPT
    );
  }
  // 页面完全加载时间
  static getLoadTime() {
    return Performance.timing.loadEventStart - Performance.timing.navigationStart;
  }
}
